import Banner from "../Banner/Banner";
import React from "react";
import './Booking.css'
import image from '../images/doctors.jpg'
import{ useState } from "react";


export function Booking (){
        const [name,setName]=useState(""); 
        const [date,setDate]=useState(""); 
        const [number,setNumber]=useState(""); 
        const changeName = (e)=>{
            setName(e.target.value)
        }
        const changeDate = (e)=>{
            setDate(e.target.value)
        }
        const changeNumber = (e)=>{
            setNumber(e.target.value)
        }
        const formHandler =(event)=>{
            event.preventDefault();
            setName("");
            setDate("");
            setNumber("")
        }
        const submitForm =()=>{
            if(number==null || date==null || number==null){
                alert('Form Field ')
                
            }
            else{
                alert('Form Submit ')
            }
        }
    return(


        <div className="booking">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-lg-6 left">
                        <h2>Book Appointment</h2>
                        <form onSubmit={formHandler}>
                            <select>
                                <option>Select Department</option>
                                <option>One</option>
                                <option>Two</option>
                                <option>Three</option>
                            </select>
                            <br/>
                            <select>
                                <option>Select Doctor</option>
                                <option>One</option>
                                <option>Two</option>
                                <option>Three</option>
                            </select>
                            <div className="form">
                                <input placeholder="Your Name" type="text" onChange={changeName} value={name} required/>
                            </div>
                            <div className="form">
                                <input placeholder="Your Number" type="text" onChange={changeName} value={number} required/>
                            </div>
                            <div className="form">
                                <input placeholder="dd/mm/yy" type="date" onChange={changeName} value={date} required/>
                            </div>
                            <button onClick={submitForm}>Send</button>
                        </form>
                    </div>
                    <div className="col-md-6 col-lg-6 right">
                        <div className="image">
                            <img src={image}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
function booking(){
    return(
        <>
            <Banner title="Booking" smtitle="booking" />
            <Booking/>
        </>
    )
}
export default booking;